<script setup lang="ts">
import { Link } from "@inertiajs/vue3"
import {
  Baby,
  GraduationCap,
  HeartPulse,
  Laptop,
  LayoutGrid,
  MessageCircleIcon,
  ShoppingBag,
  TrainFront,
} from "lucide-vue-next"

import NavFooter from "@/components/NavFooter.vue"
import NavMain from "@/components/NavMain.vue"
import NavUser from "@/components/NavUser.vue"
import { Sidebar, SidebarContent, SidebarFooter } from "@/components/ui/sidebar"
import { cn } from "@/lib/utils"
import {
  insurancePath,
  marketplacePath,
  mumsAndDadsPath,
  // mumsAndDadsPath,
  rootPath,
  studyPath,
  teleworkPath,
  transportCardPath,
} from "@/routes"
import { type NavItem } from "@/types"

import AppLogo from "./AppLogo.vue"

const headerNavItems: NavItem[] = [
  {
    title: "Dashboard",
    href: rootPath(),
    icon: LayoutGrid,
  },
]

const benefitsNavItems: NavItem[] = [
  {
    title: "Ayuda de Teletrabajo",
    href: teleworkPath(),
    icon: Laptop,
  },
  {
    title: "Ayuda de Estudios",
    href: studyPath(),
    icon: GraduationCap,
  },
  {
    title: "Marketplace",
    href: marketplacePath(),
    icon: ShoppingBag,
  },
]

const flexibleNavItems: NavItem[] = [
  {
    title: "Seguro de Salud",
    href: insurancePath(),
    icon: HeartPulse,
  },
  {
    title: "Tarjeta Transporte",
    href: transportCardPath(),
    icon: TrainFront,
  },
  {
    title: "Pago de guardería",
    href: mumsAndDadsPath(),
    icon: Baby,
  },
]

const footerNavItems: NavItem[] = [
  {
    title: "Escríbenos",
    href: "mailto:rrhh@comerciaglobalpay.com",
    icon: MessageCircleIcon,
    external: true,
  },
]
</script>

<template>
  <Sidebar collapsible="icon" variant="inset" :class="cn('')">
    <div class="px-4 pt-1">
      <Link :href="rootPath()">
        <AppLogo />
      </Link>
      <!--<p class="text-muted-foreground pb-2">Gestiona tus beneficios</p>-->
    </div>

    <SidebarContent class="mt-6">
      <NavMain :items="headerNavItems" />
    </SidebarContent>

    <SidebarContent>
      <p class="text-muted-foreground mt-6 mb-2 px-4">Añade más beneficios</p>
      <NavMain :items="benefitsNavItems" />
    </SidebarContent>

    <SidebarContent>
      <p class="text-muted-foreground mt-6 mb-2 px-4">
        Plan de Compensación Flexible
      </p>
      <NavMain :items="flexibleNavItems" />
    </SidebarContent>

    <SidebarFooter class="mt-auto">
      <NavFooter :items="footerNavItems" />
      <NavUser />
    </SidebarFooter>
  </Sidebar>
  <slot />
</template>
